<div class="gift-note">
  <div class="content">
    <form [formGroup]="formGroup">
      <pdq-card variant="popover" color="white">
        <div class="card-title"><pdq-heading element="h5">Token for Shopify</pdq-heading></div>
        <pdq-divider> </pdq-divider>
        <div class="controls-wrapper">
          <pdq-link
            label="View detailed installation instructions"
            [external]="true"
            [url]="'https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components'"></pdq-link>
          <pdq-input
            [disabled]="true"
            [formControl]="formGroup.get('usageToken')"
            label="Copy & paste this into Shopify's Components by 'Gift note token'"
            [clipboard]="true"></pdq-input>
          <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
        </div>
      </pdq-card>
      <pdq-card variant="popover" color="white">
        <div class="card-title"><pdq-heading element="h5">Settings</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="controls-wrapper">
          <pdq-input [formControl]="formGroup.get('title')" label="Internal name"></pdq-input>
          <pdq-input [formControl]="formGroup.get('internalName')" label="Internal description"></pdq-input>
        </div>
      </pdq-card>

      <pdq-card variant="popover" color="white">
        <div class="card-title"><pdq-heading element="h5">Gift message</pdq-heading></div>
        <pdq-divider></pdq-divider>
        <div class="controls-wrapper">
          <div class="gift-message-controls">
            <pdq-input
              [formControl]="formGroup.get('giftMessage.checkboxText')"
              label="Checkbox display text"></pdq-input>
            <pdq-checkbox
              [formControl]="formGroup.get('giftMessage.defaultSelected')"
              label="Preselected"
              labelSize="small"></pdq-checkbox>
          </div>
          <pdq-input
            [formControl]="formGroup.get('giftMessage.inputPlaceholder')"
            label="Message input placeholder text"></pdq-input>
        </div>
      </pdq-card>
      <pdq-card variant="popover" color="white">
        <div class="card-title">
          <pdq-heading element="h5">
            <div class="flex-row">
              Collect recipient email address
              <pdq-slide-toggle
                class="slide-toggle"
                [formControl]="formGroup.get('collectEmail.active')"></pdq-slide-toggle></div
          ></pdq-heading>
        </div>
        @if (formGroup.get('collectEmail.active').value) {
          <pdq-divider></pdq-divider>
        }
        @if (formGroup.get('collectEmail.active').value) {
          <div class="controls-wrapper">
            <pdq-input
              [formControl]="formGroup.get('collectEmail.inputPlaceholder')"
              label="Email input placeholder text"></pdq-input>
            <pdq-banner
              variant="attention"
              [closable]="false"
              bannerTitle="Please note"
              content="If you’d like to send order notifications to the gift recipient, please set up an email recipe in the ‘Integrations’ tab">
            </pdq-banner>
          </div>
        }
      </pdq-card>

      <pdq-card variant="popover" color="white">
        <div class="card-title">
          <pdq-heading element="h5">Display conditions</pdq-heading>
        </div>
        <pdq-divider></pdq-divider>
        <div class="controls-wrapper">
          <p>This Gift Note Will Only Appear If:</p>
          <pdq-rules-dynamic-form
            [formGroup]="formGroup"
            [formArrayFieldName]="formArrayFieldName"
            [rules]="restrictionsRules"
            [entities]="entities"
            [shopCurrencySymbol]="shopCurrencySymbol"
            [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
        </div>
      </pdq-card>
    </form>
  </div>
</div>
